import { render, staticRenderFns } from "./TourAccommodationEdit.vue?vue&type=template&id=0fc6a490&"
import script from "./TourAccommodationEdit.vue?vue&type=script&lang=js&"
export * from "./TourAccommodationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports